enum BillingAction {
  UPDATE_BILLING = 'billing/updateBillingPeriod',
  GET_BILLING = 'billing/getBillingPeriod'
}

export default BillingAction;
